import { useEffect, useState } from 'react';
import { getUsers, suspendUser, softDeleteUser } from '../../services/users/listUserService.js';

export const useUserList = () => {
    const [users, setUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    // modales / selección
    const [userToDelete, setUserToDelete] = useState(null);
    const [userToSuspend, setUserToSuspend] = useState(null);
    // feedback
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    // ordenamiento
    const [sortField, setSortField] = useState('');
    const [sortOrder, setSortOrder] = useState('asc');

    useEffect(() => {
        loadUsers();
    }, []);

    const loadUsers = async () => {
        const data = await getUsers();
        data.sort((a, b) => a.name.localeCompare(b.name));
        setUsers(data);
    };

    const confirmSuspend = async () => {
        try {
            const newState = !userToSuspend.suspended;
            await suspendUser(userToSuspend.id, newState);
            setUsers(prev =>
                prev.map(u => u.id === userToSuspend.id ? { ...u, suspended: newState } : u)
            );
            setSuccess(newState ? 'Usuario suspendido.' : 'Usuario activado.');
        } catch (err) {
            if (err.response?.status === 403) {
                setError('No puedes suspender a un administrador.');
            } else {
                setError('Error al cambiar el estado del usuario.');
            }
        } finally {
            setUserToSuspend(null);
        }
    };

    const confirmDelete = async () => {
        try {
            await softDeleteUser(userToDelete.id);
            setUsers(prev => prev.filter(u => u.id !== userToDelete.id));
            setSuccess('Usuario eliminado.');
        } catch (err) {
            if (err.response?.data?.message) {
                setError(err.response.data.message);
            } else {
                setError('Error al cambiar el estado del usuario.');
            }
        } finally {
            setUserToDelete(null);
        }
    };

    const handleSort = (field) => {
        const order = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';

        setSortField(field);
        setSortOrder(order);

        setUsers(prev =>
            [...prev].sort((a, b) => {
                const aValue = field.split('.').reduce((o, i) => o?.[i], a);
                const bValue = field.split('.').reduce((o, i) => o?.[i], b);

                if (aValue < bValue) return order === 'asc' ? -1 : 1;
                if (aValue > bValue) return order === 'asc' ? 1 : -1;
                return 0;
            })
        );
    };

    return {
        users,
        searchTerm,
        setSearchTerm,
        currentPage,
        setCurrentPage,
        itemsPerPage,
        userToDelete,
        setUserToDelete,
        userToSuspend,
        setUserToSuspend,
        confirmDelete,
        confirmSuspend,
        error,
        setError,
        success,
        setSuccess,
        sortField,
        sortOrder,
        setSortField,
        setSortOrder,
        handleSort
    };
}